import jwtDecode from 'jwt-decode'
import pubsub from "@viewlift/pubsub"
import { getToken } from '../../helpers'
import { getStorageItem } from "../../helpers/storageManager";
import { parseJSON } from '../utils/parseJSON'
import trackEvent from '../../helpers/trackAnalytics'
import { pushStepToFlow } from '../helper'
import { getDiscountPrice } from './Stripe/Api'
export const fetchUserObject = () => {
  const AuthenticationStore = getStorageItem('AuthenticationStore')
  let user = AuthenticationStore?.user
  return user
}
export const isUpgradePlan = () => {
    const redirected = getStorageItem("isRedirected")
    return redirected?.isUpgradePlan ? true : false
}
export const getActivePaymentMethod = async () => {
    let token = await getToken(token => token)
    let decodedToken = jwtDecode(token);
    const country = decodedToken?.countryCode || null
    const providers = (app_data?.appcmsMain?.paymentProviders) || null

    for (const paymentHandler in providers) {
      let paymentProvider = providers[paymentHandler] || null
      if (paymentProvider?.isActive && paymentProvider?.country?.includes(country)) {
        return paymentHandler
      }
      if (paymentProvider?.isActive && paymentProvider?.country?.includes('ROW')) {
        return paymentHandler
      }
    }
    return 'stripe'
}

export const addPaymentInfo = (plan,offerCodeDetails) => {
  trackEvent("add_payment_info", {
    currency: plan?.plansDetail?.recurringPaymentCurrencyCode,
    coupon: offerCodeDetails?.code || offerCodeDetails || null,
    payment_method: "Razorpay",
     items: [
      {
        item_id:  plan?.planId,
        item_name: plan?.title,
        coupon: offerCodeDetails?.code || offerCodeDetails || null,
        price: plan?.plansDetail?.recurringPaymentAmount,
        quantity: 1
      }
    ],
  },null)
}

export const getActualPrice = async (offerCodeAnalyticsData) => {
    let offerCode = sessionStorage.getItem('offerCode') || null
    let currentPlan = parseJSON(sessionStorage.getItem('currentPlan'))
    const data = {
        id: currentPlan.id || currentPlan?.planId,
        offerCode: offerCode
    }
    try {
        // handle update plans price using apply-discounted-price
        let res = await getDiscountPrice(data)
        if (offerCode) {
            let userData = fetchUserObject()
            let offer_code_applied_Payload = {
              event_label1 : res?.appliedOfferCode,
              event_label2 : res?.amount,
              event_label3 : 'pending',
              logged_in_status : userData?.userId ? 'Yes'  : 'No',
              subscribed_status : userData?.isSubscribed,
              subscription_plan : currentPlan?.title,
              event_category : 'Payment',
              event_action : 'Apply Offer Code',
              event_value : res?.amount,
              payment_status : null
            }
            trackEvent('offer_code_applied',offer_code_applied_Payload,null)
            pushStepToFlow("offer-code-applied")
            offerCodeAnalyticsData.discountAmount = res?.amount
            pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.OFFER_CODE_APPLIED, data: {...offerCodeAnalyticsData, "discountAmount": res?.amount,}});
        }
    }
    catch (err) {
        // enable error wall
        let offerStatus = err.response && err.response.data && err.response.data.code
        if (offerStatus === "OFFER_ALREADY_USED") {
            sessionStorage.removeItem("offerCode")
        }
    }
}